import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import Grid from '../common/Grid';
import Logo, { LogoType } from '../common/Logo';

const LogoTest: React.FC = () => {
  const logoTypes: LogoType[] = ['flahafast', 'flaha-agri', 'flaha-pa', 'flaha-main', 'flaha-la'];
  const sizes = ['small', 'medium', 'large', 'xlarge'] as const;

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h3" component="h1" gutterBottom textAlign="center">
        Logo Test Page
      </Typography>
      
      {logoTypes.map((logoType) => (
        <Paper key={logoType} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h5" gutterBottom>
            {logoType.toUpperCase()}
          </Typography>
          
          <Grid container spacing={3} alignItems="center">
            {sizes.map((size) => (
              <Grid xs={12} sm={6} md={3} key={size}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="subtitle2" gutterBottom>
                    {size}
                  </Typography>
                  <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    minHeight: 80,
                    border: 1,
                    borderColor: 'divider',
                    borderRadius: 1,
                    p: 2
                  }}>
                    <Logo type={logoType} size={size} />
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Paper>
      ))}
    </Container>
  );
};

export default LogoTest;
